var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotivation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#963E97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0857 14.8802L13.8476 11.6807L14.9333 10.6267L17.0857 12.7535L21.4095 8.5L22.4762 9.55395L17.0857 14.8802ZM17.9048 23.5L12.5714 22.032V14.8425H14.0571L18.781 16.574C19.2 16.7246 19.5398 16.9881 19.8004 17.3645C20.0604 17.7409 20.1905 18.155 20.1905 18.6067H18.6667C18.1333 18.6067 17.7143 18.5878 17.4095 18.5502C17.1048 18.5125 16.8381 18.4561 16.6095 18.3808L15.0857 17.8915L14.8571 18.6067L16.0571 19.0395C16.4127 19.1775 16.7365 19.2654 17.0286 19.303C17.3206 19.3407 17.6635 19.3595 18.0571 19.3595H21.7143C22.5524 19.3595 23.1429 19.4945 23.4857 19.7645C23.8286 20.034 24 20.4009 24 20.8651V21.6179L17.9048 23.5ZM8 23.1236V14.8425H11.0476V23.1236H8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivation);
export default __webpack_public_path__ + "static/media/motivation.e6f4592f0908c8d492b6bc7311115509.svg";
export { ForwardRef as ReactComponent };